import { POSITION } from '../components/utilities/truncate/constants';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var glThemes = 'indigo ,  blue ,  light-blue ,  green ,  red ,  light-red';
var glIconSizes = '8 12 14 16 24 32 48 72';

function appendDefaultOption(options) {
  return _objectSpread2(_objectSpread2({}, options), {}, {
    default: ''
  });
}

var COMMA = ',';
var glThemes$1 = glThemes.split(COMMA).map(function (glTheme) {
  return glTheme.trim();
});
var variantOptions = {
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  info: 'info',
  light: 'light',
  dark: 'dark'
};
var badgeSizeOptions = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
var badgeVariantOptions = {
  muted: 'muted',
  neutral: 'neutral',
  info: 'info',
  success: 'success',
  warning: 'warning',
  danger: 'danger'
};
var variantCssColorMap = {
  muted: 'gl-text-gray-500',
  neutral: 'gl-text-blue-100',
  info: 'gl-text-blue-500',
  success: 'gl-text-green-500',
  warning: 'gl-text-orange-500',
  danger: 'gl-text-red-500'
};
var targetOptions = ['_self', '_blank', '_parent', '_top', null];
var sizeOptions = {
  default: null,
  sm: 'sm',
  lg: 'lg'
};
var labelSizeOptions = {
  default: null,
  sm: 'sm'
};
var labelColorOptions = {
  dark: 'dark',
  light: 'light'
};
var avatarSizeOptions = [96, 64, 48, 32, 24, 16];
var avatarsInlineSizeOptions = [32, 24];
var avatarShapeOptions = {
  circle: 'circle',
  rect: 'rect'
};
var formStateOptions = {
  default: null,
  valid: true,
  invalid: false
};
var newButtonCategoryOptions = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary'
};
var newButtonVariantOptions = {
  default: 'default',
  confirm: 'confirm',
  info: 'info (deprecated)',
  success: 'success (deprecated)',
  warning: 'warning (deprecated)',
  danger: 'danger',
  dashed: 'dashed',
  link: 'link'
};
var newDropdownVariantOptions = {
  default: 'default',
  info: 'info',
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  link: 'link'
};
var newButtonSizeOptions = {
  small: 'small',
  medium: 'medium'
};
var newButtonSizeOptionsMap = {
  small: 'sm',
  medium: 'md'
};
var dropdownIconSizeOptions = [12, 16]; // size options all have corresponding styles (e.g. .s12 defined in icon.scss)

var iconSizeOptions = glIconSizes.split(' ').map(Number);
var triggerVariantOptions = {
  click: 'click',
  hover: 'hover',
  focus: 'focus'
};
var tooltipPlacements = {
  top: 'top',
  left: 'left',
  right: 'right',
  bottom: 'bottom'
}; // in milliseconds

var tooltipDelay = {
  show: 200,
  hide: 0
};
var popoverPlacements = {
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left'
};
var columnOptions = {
  stacked: 'stacked',
  tiled: 'tiled'
};
var alignOptions = {
  left: 'left',
  center: 'center',
  right: 'right',
  fill: 'fill'
};
var alertVariantOptions = {
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  info: 'info',
  tip: 'tip'
};
var alertVariantIconMap = {
  success: 'check-circle',
  warning: 'warning',
  danger: 'error',
  info: 'information-o',
  tip: 'bulb'
};
var colorThemes = {
  indigo: 'theme-indigo-900',
  'light-indigo': 'theme-indigo-700',
  blue: 'theme-blue-900',
  'light-blue': 'theme-blue-700',
  green: 'theme-green-900',
  'light-green': 'theme-green-700',
  red: 'theme-red-900',
  'light-red': 'theme-red-700',
  dark: 'gray-900',
  light: 'gray-700'
};
var modalButtonDefaults = {
  actionPrimary: {
    variant: 'confirm',
    category: 'primary'
  },
  actionSecondary: {
    variant: 'confirm',
    category: 'secondary'
  },
  actionCancel: {
    variant: 'default'
  }
};
var tabsButtonDefaults = {
  actionPrimary: {
    variant: 'success',
    category: 'primary'
  },
  actionSecondary: {
    variant: 'default',
    category: 'secondary'
  },
  actionTertiary: {
    variant: 'default'
  }
};
var tokenVariants = ['default', 'search-type', 'search-value'];
var resizeDebounceTime = 200;
var variantOptionsWithNoDefault = appendDefaultOption(variantOptions);
var sizeOptionsWithNoDefault = appendDefaultOption(sizeOptions); // Datetime constants

var defaultDateFormat = 'YYYY-MM-DD';
var bannerVariants = ['promotion', 'introduction'];
var maxZIndex = 10; // Button constants

var deprecatedButtonCategoryOptions = {
  tertiary: 'tertiary',
  primary: 'primary',
  secondary: 'secondary'
};
var deprecatedButtonVariantCategoryMap = {
  default: 'tertiary',
  primary: 'primary',
  secondary: 'primary',
  dark: 'primary',
  light: 'primary',
  info: 'primary',
  success: 'primary',
  warning: 'primary',
  danger: 'primary',
  'outline-info': 'secondary',
  'outline-success': 'secondary',
  'outline-warning': 'secondary',
  'outline-danger': 'secondary'
};
var deprecatedButtonVariantOptions = {
  primary: 'primary',
  secondary: 'secondary',
  dark: 'dark',
  light: 'light'
};
var deprecatedButtonOutlineVariantOptions = {
  'outline-info': 'outline-info',
  'outline-success': 'outline-success',
  'outline-warning': 'outline-warning',
  'outline-danger': 'outline-danger'
};
var buttonVariantOptions = {
  default: 'default',
  info: 'info',
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  link: 'link',
  loading: 'loading'
};
var availableButtonVariantOptions = _objectSpread2(_objectSpread2(_objectSpread2({}, buttonVariantOptions), deprecatedButtonVariantOptions), deprecatedButtonOutlineVariantOptions);
var deprecatedButtonSizeOptions = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
var modalSizeOptions = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
var focusableTags = ['INPUT', 'TEXTAREA', 'A', 'BUTTON', 'SELECT'];
var keyboard = {
  escape: 'Escape',
  backspace: 'Backspace',
  delete: 'Delete',
  left: 'Left',
  arrowLeft: 'ArrowLeft',
  right: 'Right',
  arrowRight: 'ArrowRight',
  home: 'Home',
  end: 'End'
};
var truncateOptions = POSITION;
var formInputSizes = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  '(unset or null)': null
};
var toggleLabelPosition = {
  hidden: 'hidden',
  left: 'left',
  top: 'top'
};
var tooltipActionEvents = ['open', 'close', 'enable', 'disable'];

export { COMMA, alertVariantIconMap, alertVariantOptions, alignOptions, availableButtonVariantOptions, avatarShapeOptions, avatarSizeOptions, avatarsInlineSizeOptions, badgeSizeOptions, badgeVariantOptions, bannerVariants, buttonVariantOptions, colorThemes, columnOptions, defaultDateFormat, deprecatedButtonCategoryOptions, deprecatedButtonOutlineVariantOptions, deprecatedButtonSizeOptions, deprecatedButtonVariantCategoryMap, deprecatedButtonVariantOptions, dropdownIconSizeOptions, focusableTags, formInputSizes, formStateOptions, glThemes$1 as glThemes, iconSizeOptions, keyboard, labelColorOptions, labelSizeOptions, maxZIndex, modalButtonDefaults, modalSizeOptions, newButtonCategoryOptions, newButtonSizeOptions, newButtonSizeOptionsMap, newButtonVariantOptions, newDropdownVariantOptions, popoverPlacements, resizeDebounceTime, sizeOptions, sizeOptionsWithNoDefault, tabsButtonDefaults, targetOptions, toggleLabelPosition, tokenVariants, tooltipActionEvents, tooltipDelay, tooltipPlacements, triggerVariantOptions, truncateOptions, variantCssColorMap, variantOptions, variantOptionsWithNoDefault };
